import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CreateRequisitionRequest, HttpResponse, Requisition } from "@/types";

export function useCreateRequisition() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({
      createRequisitionRequest,
    }: {
      createRequisitionRequest: CreateRequisitionRequest;
    }) => {
      const path = `jobs/${currentJobId}/requisitions`;
      const res = await guacHttpClient.post<
        Requisition,
        HttpResponse<Requisition>,
        CreateRequisitionRequest
      >(path, createRequisitionRequest);

      return res.data;
    },
    onSuccess: () => {
      // Invalidate queries that have job intake
      void queryClient.invalidateQueries({
        queryKey: ["jobs", currentCompanyId],
      });
    },
  });

  return mutation;
}
